import {UnicodeSymbols} from '@/interfaces/unicodeSymbols';

const unicodeHtmlSymbolsForDegree: UnicodeSymbols = {
  '-': '¯',
  '1': '¹',
  '2': '²',
  '3': '³',
  '4': '⁴',
};

const unicodeSymbolsForDegree: UnicodeSymbols = {
  '-': '\u207B;',
  '1': '\u00B9',
  '2': '\u00B2',
  '3': '\u00B3',
  '4': '\u2074',
};

// Заменяем степень в виде крышки и числа на соответствующий символ юникода
export function replaceCaret(base: string, degree: string, unicode?: boolean): string {
  const degreeUnicode = degree
    .split('')
    .map(symbol => {
      return unicode ? unicodeSymbolsForDegree[symbol] : unicodeHtmlSymbolsForDegree[symbol];
    })
    .join('');
  return `${base}${degreeUnicode}`;
}

// Форматируем единицы измерения в подписях на графике. Заменяем степень вида ^n на соответствующий символ юникода
export function formatUnit(unit: string, unicode?: boolean) {
  const signCaret = unit.match('(.+)\\^(\\-?[1234]{1})');
  return signCaret ? `${replaceCaret(signCaret[1], signCaret[2], unicode)}` : unit;
}

export function replaceUnicodeByCaret(
  title: string,
  minusSymbol: string | null,
  degreeSymbol: string,
): string {
  const reverseUnicodeSymbols = Object.assign(
    {},
    ...Object.entries(unicodeHtmlSymbolsForDegree).map(entry => ({[entry[1]]: entry[0]})),
  );
  if (minusSymbol) {
    title = title.replace('&#8315;', '^-');
    title = title.replace(degreeSymbol, reverseUnicodeSymbols[degreeSymbol]);
  } else title = title.replace(degreeSymbol, `^${reverseUnicodeSymbols[degreeSymbol]}`);
  return title;
}

// Форматируем единицы измерения в подписях на графике для сохранения картинки. Заменяем степень в юникоде на вид ^n
export function reverseUnitInTitle(title: string) {
  const signCaret = title.match(/(&#8315;)?(&#185;|&#178;|&#179;|&#8308;)/);
  return signCaret ? replaceUnicodeByCaret(title, signCaret[1], signCaret[2]) : title;
}
